import styled from 'styled-components';

export const PopupMainWrapper = styled.div(
    props =>`
    width: 60%;
    height: 50rem;
    max-height: 50rem;
    overflow:auto;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    position: absolute;
    z-index: ${props.theme.misc.zIndex.xxlarge};
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    box-shadow: 0 2px 2px 0 ${props.theme.colors.black.light3};

    @media only screen and (min-width: 320px) and (max-width: 767px){ 
        width: 95%;
    }

    @media only screen and (min-width: 768px) and (max-width: 1024px){ 
        width: 75%;
    }
`);

export const PopupNameCorrect = styled.div(
    props => `
        width: 40%;
        height: 25rem;
        max-height: 50rem;
        overflow:auto;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        border-radius: ${props.theme.misc.borderRadius.base};
        position: absolute;
        z-index: ${props.theme.misc.zIndex.xxlarge};
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        box-shadow: 0 2px 2px 0 ${props.theme.colors.black.light3};

        @media only screen and (min-width: 320px) and (max-width: 767px){ 
            width: 95%;
        }

        @media only screen and (min-width: 768px) and (max-width: 1024px){ 
            width: 75%;
        }
    `
)

export const PopupHeadWrap = styled.div(
    props => `
    width: 100%;
    height: 6rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:${props.theme.spacing.large.l20};
    border-bottom: 1px solid ${props.theme.colors.grey.lighte5};
    position: sticky;
    top:0;
    background-color: ${props.theme.colors.white.base};
    z-index: 1;
`);

export const PopupHeadTextWrap = styled.div`
    width:90%;
    display: flex;
`;

export const PopupHeadCloseWrap = styled.div`
    width:10%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const PopupCloseBtn = styled.a(
    props =>`
    text-decoration: none;
    color: ${props.theme.colors.black.base};
`);

export const PopupHeadText = styled.p(
    props =>`
    font-size: ${props.theme.font.large.font20};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.bold};
`);

export const PopupBodyWrapper = styled.div(
    props =>`
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l20} 0 0;
    flex-direction: column;
`);


export const PopupContentText = styled.p(
    props =>`
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.black.base};;
    line-height: ${props.theme.font.lineHeight.base};
`);

export const PopupNameInfoText = styled.p(
    props =>  `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};;
        line-height: ${props.theme.font.lineHeight.large};
    `
);

export const PopupContentWrap = styled.div(
    props => `
        width:100%;
        min-height: 34rem;
        display:flex;
    `
);

export const PopupContentNameWrap = styled.div(
    props => `
        width:100%;
        min-height: 11rem;
        display:flex;
        justtify-content: center;
        padding: 0 ${props.theme.spacing.large.l20};
    `
);

export const PopuoContentList = styled.ul(
    props =>`
    width:100%;
    padding-left:${props.theme.spacing.large.l30};
    padding-top:${props.theme.spacing.large.l20};
    list-style-position: outside;
    li{
        width:100%;
        padding-bottom: ${props.theme.spacing.base};
        line-height: ${props.theme.font.lineHeight.base};
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
    }
`);

export const ButtonWrapper = styled.div(
    props =>`
    width:100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: ${props.theme.spacing.base};
    position: sticky;
    bottom: 0;
    left:0;
    background-color: ${props.theme.colors.white.base};
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.2);
`);

export const CancelBtn = styled.p(
    props =>`
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l20};
    font-size: ${props.theme.font.large.font20};
    color: ${props.theme.colors.black.base};
    background-color: ${props.theme.colors.grey.lighte5};
    border-radius: ${props.theme.misc.borderRadius.base};
    margin-right: ${props.theme.spacing.large.l30};
    cursor: pointer;
`);

export const AgreeBtn = styled.p(
    props =>`
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l20};
    font-size:${props.theme.font.large.font20};
    color: ${props.theme.colors.white.base};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};;
    box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light3};
    background-image: linear-gradient(93deg, #53b2fe 0%, #065af3 130%);
    cursor: pointer;
`);
